import { Component, input, InputSignal, output, OutputEmitterRef, inject } from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {DsToggleButtonModule} from "@bmw-ds/components";
import {ServiceCaseHolder} from "../../../../core/service-case/models/service-case-holder";

@Component({
    selector: 'app-shopping-cart-button',
    imports: [
        AsyncPipe,
        DsToggleButtonModule
    ],
    templateUrl: './shopping-cart-button.component.html'
})
export class ShoppingCartButtonComponent {
  serviceCaseHolder: ServiceCaseHolder = inject(ServiceCaseHolder);

  active: InputSignal<boolean> = input();
  buttonClicked: OutputEmitterRef<void> = output<void>();

  onClick(): void {
    this.buttonClicked.emit();
  }
}
